import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import './index.css';
import './App.css';

import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import './utils/axiosInterceptor';
import { clearLegacyAuthStorage } from './utils/clearLegacyAuthStorage';
import { installLoyaltyEarlyAuth } from './utils/loyaltyEarlyAuth';

clearLegacyAuthStorage();
installLoyaltyEarlyAuth();

// Set CSS variable so plain CSS can use the same font as the MUI theme
if (typeof document !== 'undefined' && theme && theme.typography && theme.typography.fontFamily) {
  document.documentElement.style.setProperty('--app-font-family', theme.typography.fontFamily);
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </Router>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();